import { useEffect } from 'react';

import { authSession } from '@/auth/authSession';
import { useAuth } from '@/auth/useAuth';
import { meAtom } from '@/state/api/meAtoms';
import type { Store } from '@/types/store';

/**
 * Keeps `store`'s /me answer read while the page is signed in to an organization. That is
 * AuthGate's condition, so every reader behind the gate shares this one load. A cookie-only tab
 * takes its display user from the answer.
 */
export function useSessionMe(store: Store): void {
    const { isSignedIn, orgId } = useAuth();
    const isReading = isSignedIn && orgId !== null;
    useEffect((): (() => void) | undefined => {
        if (!isReading) {
            return undefined;
        }
        return store.sub(meAtom, (): void => {
            const { me } = store.get(meAtom);
            if (me !== null) {
                authSession.setCookieSessionUser(me);
            }
        });
    }, [store, isReading]);
}
